<div class="shimmer">
  <ng-container *ngIf="loading"> 

    <ng-container *ngIf="type === 'grid'">
      <div *ngIf="showGridSkeleton" class="grid-skeleton">
        <ejs-skeleton *ngFor="let width of gridWidths" [width]="width" shimmerEffect="Wave" class="skeleton-text">
        </ejs-skeleton>
      </div>
    
      <div *ngIf="showGridError" class="error-message">
        Error fetching data.
      </div>
    </ng-container>
    
  </ng-container>
</div>